import React from 'react';
import _ from 'lodash';
import { Dialog } from '@tencent/spaui';
import { RPCFactory } from '../../../utils/RequestUtil';
import { OPERATION_TYPE } from './config';
const bindParams = ['subAccountId', 'subWeChatAppId'];
const authParams = ['mainAccountId', 'mainWeChatAppId'];

const getSubId = (row) => (row.subWeChatAppId && row.subWeChatAppId !== '' ? row.subWeChatAppId : row.subAccountId);

const getMainId = (row) =>
  row.mainWeChatAppId && row.mainWeChatAppId !== '' ? row.mainWeChatAppId : row.mainAccountId;

const operationSettings = {
  withdrawBind: {
    uri: 'withdrawBind',
    params: bindParams,
    getLabel: (row) => `确定解除账号${getSubId(row)}的绑定`,
  },
  confirmBind: {
    uri: 'confirmBind',
    params: authParams,
    getLabel: (row) => `确定授权给账号${getMainId(row)}`,
  },
  denyBind: {
    uri: 'denyBind',
    params: authParams,
    getLabel: (row) => `确定拒绝账号${getMainId(row)}的授权`,
  },
  unbindAccount: {
    uri: 'unbindAccount',
    params: authParams,
    getLabel: (row) => `确定撤销对账号${getMainId(row)}的授权`,
  },
  withdrawUnbind: {
    uri: 'withdrawUnbind',
    params: authParams,
    getLabel: (row) => `确定继续对账号${getMainId(row)}的授权`,
  },
  confirmUnbind: {
    uri: 'confirmUnbind',
    params: bindParams,
    getLabel: (row) => `同意解除账号${getSubId(row)}的绑定`,
  },
};

const Confirm = (props) => {
  const content = props && props.data ? props.data : {};

  const { type, row } = content;

  const onSubmit = () => {
    const settings = operationSettings[type];

    if (!settings) {
      return;
    }
    const params = settings.params.reduce((prev, cur) => _.extend(prev, { [cur]: row[cur] }), {});
    RPCFactory.multiaccount[settings.uri](params)
      .done((resp) => {
        props.onSubmit(type);
        if (type == OPERATION_TYPE.confirmBind) {
          window.location.reload();
        }
      })
      .fail((status, msg) => {
        props.feedbackHooks.showErrorTip(msg ? msg : '网络错误, 稍后重试');
        props.onClose();
      });
  };
  return (
    <Dialog
      type={type == OPERATION_TYPE.confirmBind ? 'normal' : 'simple'}
      show={props.show}
      onSubmit={onSubmit}
      onCancel={props.onClose}
      onClose={props.onClose}
      style={{ width: '306px' }}
      eventTarget={props.target}
      eventTargetPlacement={'left'}
      backdrop={type == OPERATION_TYPE.confirmBind}
      className={type == OPERATION_TYPE.confirmBind ? 'spaui-dialog-confirm-normal' : 'modal-mini'}
      title={type == OPERATION_TYPE.confirmBind ? operationSettings[type].getLabel(row) : ''}
      hideHeader={type != OPERATION_TYPE.confirmBind}
      enabledBackdropClose
    >
      {type == OPERATION_TYPE.confirmBind
        ? "您可以选择一个账号进行授权，选择后其他的授权状态默认变更为'已拒绝'。"
        : operationSettings[type].getLabel(row)}
    </Dialog>
  );
};

export default Confirm;
